import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {CarouselArrow} from './CarouselArrow';
import {observer} from 'mobx-react';

interface ImageCarouselProps<T = any> {
    images: T[];
    itemsPerSlide?: number;
    transitionTime?: number;
    animationHandler?: 'slide' | 'fade';
    renderImage: (image: T, index: number) => JSX.Element;
    arrowIcon: JSX.Element;
}

@observer
export class ImageCarousel<T = any> extends TechseeBaseComponent<ImageCarouselProps<T>> {
    renderInternal(): JSX.Element {
        const {
            images,
            itemsPerSlide = 3,
            transitionTime = 500,
            animationHandler = 'fade',
            renderImage,
            arrowIcon
        } = this.props;

        if (images.length <= 1) {
            return <></>;
        }

        const handleClick = (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            // if (onImageClick) {
            //     onImageClick(img.imageUrl, img.label);
            // }
        };
        const createSlide = (key: string, imagesToRender: T[], baseIndex: number) => (
            <div key={key} className='carousel-slide'>
                {imagesToRender.map((img, index) => renderImage(img, baseIndex + index))}
            </div>
        );
        const slides: JSX.Element[] = [];

        if (images.length <= itemsPerSlide) {
            // Show all images in one slide when we have fewer than itemsPerSlide
            slides.push(createSlide('slide-0', images, 0));
        } else {
            // Create sliding windows when we have more images than itemsPerSlide
            for (let i = 0; i <= images.length - itemsPerSlide; i++) {
                const slideImages = images.slice(i, i + itemsPerSlide);
                slides.push(createSlide(`slide-${i}`, slideImages, i));
            }
        }

        return (
            <Carousel
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
                infiniteLoop={false}
                centerMode={false}
                swipeable={false}
                useKeyboardArrows={true}
                showArrows={true}
                emulateTouch={false}
                stopOnHover={false}
                animationHandler={animationHandler}
                transitionTime={transitionTime}
                renderArrowPrev={(onClickHandler, hasPrev) => (
                    <CarouselArrow
                        onClick={onClickHandler}
                        isEnabled={hasPrev}
                        direction='prev'
                        arrowIcon={arrowIcon}
                    />
                )}
                renderArrowNext={(onClickHandler, hasNext) => (
                    <CarouselArrow
                        onClick={onClickHandler}
                        isEnabled={hasNext}
                        direction='next'
                        arrowIcon={arrowIcon}
                    />
                )}>
                {slides}
            </Carousel>
        );
    }
}
